import { css } from '@emotion/css';
import { ColorHex } from '../ui/Colors.ts';

import bg from './bg_landingpage.jpg';
import { Box } from '@mui/material';

export function AlternativeLanding(props: Props) {
    return (
        <div className={topStyle}>
            <Box
                sx={{
                    alignSelf: 'center',
                }}
            >
                {props.children}
            </Box>
        </div>
    );
}

interface Props {
    children: React.ReactNode;
}

const topStyle = css`
    background-image: url(${bg});
    background-color: ${ColorHex.black};
    background-size: cover;
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
`;
